import type { GameSettings } from '@shared/game';
import { DEFAULT_BOARD_MODIFIERS } from '@shared/game';

export const QUICK_PLAY_PRESET: GameSettings = {
  maxRounds: 10,
  targetTrophies: 3,
  turnTimer: 20,
  startingKeys: 35,
  trophyCost: 25,
  minDiceRoll: 1,
  maxDiceRoll: 20,
  playerCount: 4,
  weaponsCacheRespawn: 3,
  boardModifiers: DEFAULT_BOARD_MODIFIERS,
  betweenRoundMinigamesEnabled: true,
};

export const QUICK_PLAY_FILL_COUNTDOWN_MS = 15000;
export const QUICK_PLAY_MIN_PLAYERS_FOR_AUTOSTART = 2;
